/**
 * #775 — per-caregiver Command Center access.
 *
 * Command Center is the pro surface; this app is the light one. They serve the
 * same caregivers, so who gets the pro surface is a per-person decision a
 * caregiver admin makes here. The backend is GMA-TECH/cortex-be#1009 / #1412.
 *
 * Follows the pontosenseCaregiverAccessService contract: every helper returns
 * the already-parsed payload or throws an Error carrying the server's message.
 * Components rely on that, never on a raw Response.
 *
 * `enabled` is REJECTED unless it is already a boolean. The endpoint refuses a
 * string or a number rather than coercing, because `"no"` and `"false"` are
 * truthy in JavaScript — coercing here would turn a caller's bug into granted
 * access, which is the opposite of what the strict endpoint is for. Failing at
 * this boundary also saves a request that could only ever 400.
 */

import { apiRequest } from "./baseApi";
import { parseJsonOrThrow } from "./responseUtils";

export const setCommandCenterAccess = async (caregiverId, enabled) => {
  if (typeof enabled !== "boolean") {
    throw new Error("Command Center access must be set to true or false");
  }

  const res = await apiRequest(
    `caregivers/${caregiverId}/command-center-access`,
    {
      method: "PUT",
      body: { enabled },
      version: "v1",
    },
  );
  return parseJsonOrThrow(res, "Command Center access");
};
